import React from 'react';
import SharingSetupModal from '../SharingSetupModal';
import type { SharingSetupProps } from '../types';
import { newsInjectableFields } from './injectableFields';
import defaultShareFormYaml from './default_share_form.yaml?raw';

/**
 * News share-message form editor: the shared shell seeded with the news form.
 */
const SharingSetup: React.FC<SharingSetupProps> = props => (
  <SharingSetupModal
    {...props}
    defaultShareFormYaml={defaultShareFormYaml}
    injectableFields={newsInjectableFields}
  />
);

export default SharingSetup;
